var _defs, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 0 L 0 0 0 20",
    fill: "none",
    stroke: "white",
    strokeWidth: 0.5,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 10,
    height: 10,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 1,
    fill: "white",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "stars",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L18,10 L28,10 L20,15 L23,25 L15,20 L7,25 L10,15 L2,10 L12,10 Z",
    fill: "white",
    opacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#grid)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#dots)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#stars)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.afe72b967a512313b1fc2d571e0522ab.svg";
export { ForwardRef as ReactComponent };